import { render, staticRenderFns } from "./SpecialistDashboards.vue?vue&type=template&id=afadb3e6&scoped=true&"
import script from "./SpecialistDashboards.vue?vue&type=script&lang=js&"
export * from "./SpecialistDashboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afadb3e6",
  null
  
)

export default component.exports